import TaskType from "shared/models/TaskType";
import TaskTypeDto from "./api/TaskTypeDto";

export class TaskTypeFromResponse {
    constructor(private taskTypeFromResponse: TaskTypeDto) {}

    taskType(): TaskType {
        return {
            id: this.taskTypeFromResponse.id,
            code: this.taskTypeFromResponse.code,
            description: this.taskTypeFromResponse.description,
        };
    }
}
